import { useEffect, useMemo, useCallback } from "react";
import { captureError } from "@core-ui/utils/Error";

interface FocusTrapProps {
    selector?: string;
}

const getElement = (selector: string): HTMLElement | null => {
    return document.querySelector<HTMLElement>(selector);
};

export const useFocusTrap = ({ selector = "div#root" }: Partial<FocusTrapProps> = {}): void => {
    const element = useMemo(() => getElement(selector), [selector]);
    const setAriaHidden = useCallback((element: HTMLElement | null, shouldHide: boolean): void => {
        if (shouldHide) {
            if (element == null) {
                captureError(`Invalid element was provided`);
                return;
            }
            element.setAttribute("aria-hidden", "true");
            return;
        }
        if (element) {
            element.removeAttribute("aria-hidden");
        }
    }, []);

    useEffect(() => {
        setAriaHidden(element, true);

        return (): void => setAriaHidden(element, false);
    }, [element, setAriaHidden]);
};

export default useFocusTrap;
